import { useModels } from '@k3/core';
import { Model } from '@k3/core/dist/src/lib/types/model.interface';
import { Autocomplete, TextField } from '@mui/material';

export interface ModelSelectorProps {
  label: string;
  modelKey?: string | string[];
  multiple?: boolean;
  onChange?: (newValue: string) => void;
  onChangeMultiple?: (newValue: string[]) => void;
}

export const ModelSelector = ({
  label = 'Modell',
  modelKey = '',
  multiple = false,
  onChange,
  onChangeMultiple,
}: ModelSelectorProps) => {
  const models = (useModels() ?? []).filter((model) => model.key);

  const handleModelChange = (newValue: Model | Model[]) => {
    if (Array.isArray(newValue)) {
      const keys = (newValue as Model[]).reduce(
        (acc, model) => (model.key ? [...acc, model.key] : acc),
        [] as string[]
      );
      onChangeMultiple?.(keys);
    } else {
      if (newValue?.key) {
        onChange?.(newValue.key);
      }
    }
  };

  const value = multiple
    ? models.filter((model) => model.key && modelKey.includes(model.key))
    : models?.find((model) => model.key === modelKey) ?? null;

  return (
    <Autocomplete
      id="model-selector"
      options={models}
      multiple={multiple}
      sx={{ maxWidth: 1.0 }}
      disableCloseOnSelect={multiple}
      value={value}
      renderInput={(params) => <TextField {...params} label={label} />}
      onChange={(_event, newValue) => {
        if (newValue) {
          handleModelChange(newValue);
        }
      }}
    />
  );
};
